import { ReactComponent as ChevronDown } from 'ui/icons/icon-chevron-down-big.svg';
import styles from './BackToTop.module.scss';

export interface BackToTopProps {
    visible: boolean;
    onScrollTop: () => void;
    onScrollDown: () => void;
    scrollDownLabel: string;
    scrollTopLabel: string;
}

export const BackToTop: React.FC<BackToTopProps> = ({
    visible,
    onScrollTop,
    onScrollDown,
    scrollDownLabel,
    scrollTopLabel,
}) => (
    <>
        <button
            type="button"
            className={`${styles.ScrollButton} ${visible ? styles.ScrollButton___hidden : ''}`}
            onClick={onScrollDown}
            aria-label={scrollDownLabel}
            title={scrollDownLabel}
            tabIndex={visible ? -1 : 0}
            aria-hidden={visible}
        >
            <span className={styles.ChevronDouble}>
                <ChevronDown aria-hidden="true" />
                <ChevronDown aria-hidden="true" />
            </span>
        </button>

        <button
            type="button"
            className={`${styles.ScrollButton} ${!visible ? styles.ScrollButton___hidden : ''}`}
            onClick={onScrollTop}
            aria-label={scrollTopLabel}
            title={scrollTopLabel}
            tabIndex={visible ? 0 : -1}
            aria-hidden={!visible}
        >
            <span className={styles.ChevronUpWrapper}>
                <ChevronDown className={styles.ChevronInverted} aria-hidden="true" />
            </span>
            <span className={styles.ScrollButton__label}>TOP</span>
        </button>
    </>
);
